<template>
  <div class="cart-item">
    <div class="cart-item__delete-button-wrapper">
      <button
        @click="$emit('delete', item)"
        class="close-button"
        aria-label="Delete item"
      ></button>
    </div>
    <div class="cart-item__inner">
      <div class="cart-item__thumbnail-carousel" v-if="item.designs.length > 1">
        <vue-glide :per-view="1" @glide:run="handleGlideRun" ref="carousel">
          <vue-glide-slide v-for="(design, index) in item.designs" :key="index">
            <img :src="design.thumbnail" alt="" />
          </vue-glide-slide>
          <template slot="control">
            <button
              v-for="i in item.designs.length"
              class="cart-item__carousel-bullet"
              :aria-label="`Go to slide thumbnail ${i}`"
              :data-glide-dir="`=${i - 1}`"
            ></button>
          </template>
        </vue-glide>
      </div>
      <div class="cart-item__thumbnail" v-else>
        <img :src="item.designs[0].thumbnail" alt="" />
      </div>
      <div>
        <p v-if="!isValidQuantity" class="cart-item__sheet-error">
          Sheet not complete
        </p>
        <p class="cart-item__name">
          {{ item.name }}
        </p>
        <div class="cart-item__quantity-wrapper">
          <Quantity :value="item.quantity" @change="updateQuantity" />
          <button class="cart-item__edit-sheet" @click="$emit('edit', item)">
            {{ item.metaData.isSheet ? 'Edit Sheet' : 'Edit' }}
          </button>
        </div>
        <p class="cart-item__price">
          {{ item.price }}
        </p>
      </div>
    </div>
  </div>
</template>

<script>
import Quantity from './Quantity.vue';

export default {
  props: {
    item: {
      type: Object,
      required: true
    }
  },
  methods: {
    updateQuantity(quantity) {
      this.item.quantity = quantity;
      this.$emit('change', this.item);
    },
    handleGlideRun() {
      this.setActiveBullet();
      this.scrollControls();
    },
    setActiveBullet() {
      const index = this.$refs.carousel.glide.index;
      const bullets = this.$refs.carousel.$el.querySelectorAll(
        '.cart-item__carousel-bullet'
      );

      bullets.forEach((bullet, i) => {
        bullet.classList.toggle('active', i === index);
      });

      this.scrollControls();
    },
    scrollControls() {
      const controls = this.$refs.carousel.$el.querySelector(
        'div[data-glide-el="controls"]'
      );

      controls.scroll({
        left: this.$refs.carousel.$el.querySelector(
          '.cart-item__carousel-bullet.active'
        ).offsetLeft,
        behavior: 'smooth'
      });
    }
  },
  mounted() {
    if (this.item.designs.length > 1) {
      this.setActiveBullet();
    }
  },
  computed: {
    isValidQuantity() {
      const { isSheet, maxItems } = this.item.metaData;

      const totalQuantity = this.item.designs.reduce((quantity, design) => {
        return quantity + design.quantity;
      }, 0);

      return !isSheet || totalQuantity === maxItems;
    }
  },
  components: {
    Quantity
  }
};
</script>
